import React, { useEffect, useState, useContext } from "react";
import Footer from "../components/footer";
import Header from "../components/header";
import { CartContext } from "../../../contexts/cartContext";
import { CurrencyContext } from "../../../contexts/currencyContext"; // Import context
import { Link, useNavigate } from "react-router-dom";
import '../../../css/checkout.css';
import axios from "axios";

const MyAccount = () => {

    const [selectedProfileImage, setSelectedProfileImage] = useState(null);
    const [isCollapsed, setIsCollapsed] = useState(true);
    const [isOpen, setIsOpen] = useState(false);
    const [addressType, setAddressType] = useState(1); // 1: Shipping, 2: Billing   
    const [addressId, setAddressId] = useState();

    const [addressShip, setAddressShip] = useState([]);
    const [addressBill, setAddressBill] = useState([]);
    const [userData, setUserData] = useState([]);
    const [defaultAddressId, setDefaultAddressId] = useState(null); // Store the default address ID
    const [defaultShipAddressId, setDefaultShipAddressId] = useState(null);
    const [defaultBillAddressId, setDefaultBillAddressId] = useState(null);
    const [countries, setCountries] = useState([]);
    const [selectedCountry, setSelectedCountry] = useState("INDIA"); // Default country: India (ID = 99)
    const [billingDetails, setBillingDetails] = useState({
        BillBuyerName: "",
        BillAddress: "",
        BillArea: "",
        BillState: "",
        BillCountry: "",
        BillZIP: "",
        BillMobile: "",
        BillDefault: false,
        TradeName: "",
        GSTIN: "",
    });
    const [shippingDetails, setShippingDetails] = useState({
        ShipBuyerName: "",
        ShipAddress: "",
        ShipArea: "",
        ShipState: "",
        ShipCountry: "",
        ShipZIP: "",
        ShipMobile: "",
        ShipDefault: false,
    });
    const navigate = useNavigate();

    const { cart, updateCart } = useContext(CartContext);
    const [cartData, setCartData] = useState([]);

    const [summary, setSummary] = useState({ mrp: 0, discount: 0, gstAmount: 0, subTotal: 0, shipping: 0, shippingGST: 0, totalAmount: 0, });


    const { currencyContxt } = useContext(CurrencyContext); // Use context

    const toggleMenu = () => {
        setIsOpen(!isOpen);
    };
    const handleToggle = () => {
        setIsCollapsed(!isCollapsed);
    };
    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden';
            document.body.style.paddingRight = '17px';
        } else {
            document.body.style.overflow = '';
            document.body.style.paddingRight = '';
        }
    })
    const userInfo = JSON.parse(localStorage.getItem('user-info'));
    // Fetch buyer addresses using buyer_id
    useEffect(() => {
        fetchAddresses();  // Call the function on component load
    }, []);

    // Move this function outside useEffect
    const fetchAddresses = async () => {
        if (userInfo && userInfo.buyer_id) {
            try {
                const responseShip = await fetch(`https://igapi.heuristticminds.com/api/BuyerList/Get-GetBuyerShippingAddressByBuyerID?buyerID=${userInfo.buyer_id}`);
                const responseBill = await fetch(`https://igapi.heuristticminds.com/api/BuyerList/Get-GetBuyerBillingAddressByBuyerID?buyerID=${userInfo.buyer_id}`);
                const responseUser = await fetch(`https://igapi.heuristticminds.com/api/UsersList/Get-GetUserAddressByUserID?User_ID=${userInfo.buyer_id}`);
                const dataShip = await responseShip.json();
                const dataBill = await responseBill.json();
                const dataUser = await responseUser.json();

                if (dataShip) {
                    setAddressShip(dataShip);  // Bind the fetched shipping addresses

                    const defaultShipAddress = dataShip.find(addr => addr.defaultShip);
                    if (defaultShipAddress) setDefaultShipAddressId(defaultShipAddress.id);  // Set default shipping address ID
                }

                if (dataBill) {
                    setAddressBill(dataBill);  // Bind the fetched billing addresses

                    const defaultBillAddress = dataBill.find(addr => addr.defaultBill);
                    if (defaultBillAddress) setDefaultBillAddressId(defaultBillAddress.id);  // Set default billing address ID
                }
                if (dataUser) {
                    setUserData(dataUser); // Bind the fetched User Data
                }
            } catch (error) {
                console.error("Error fetching addresses:", error);
            }
        }
    };
    // Fetch countries and set default country to India
    useEffect(() => {
        const fetchCountries = async () => {
            try {
                const response = await fetch('https://igapi.heuristticminds.com/api/BindDropDownList/Bind-BindCountryList');
                const countryData = await response.json();
                setCountries(countryData);
                // Set default country to India (ID-based)
                const india = countryData.find(country => country.countryName === "INDIA");
                if (india) {
                    setSelectedCountry(india.id); // Use ID for setting the selected value
                    setShippingDetails(prevDetails => ({
                        ...prevDetails,
                        ShipCountry: india.countryName, // For display purposes
                    }));
                }
            } catch (error) {
                console.error("Error fetching countries:", error);
            }
        };
        fetchCountries();
    }, []);

    // Handle Add New Shipping Address button click
    const handleAddNewShipAddress = () => {
        if (addressShip.length < 3) {


            setAddressType(1); // Shipping
            const india = countries.find(country => country.countryName === "INDIA");
            if (india) {
                setSelectedCountry(india.id);
            }
            setShippingDetails({
                ShipBuyerName: "",
                ShipAddress: "",
                ShipArea: "",
                ShipState: "",
                ShipCountry: "India",  // For display purposes
                ShipZIP: "",
                ShipMobile: ""
            });
            setIsOpen(true); // Open the modal for adding a new address
        }
        else {
            alert("You can only have a maximum of 3 Shipping addresses.");
        }
    };

    const handleAddNewBillAddress = () => {
        if (addressBill.length < 3) {
            setAddressType(2); // Billing
            const india = countries.find(country => country.countryName === "INDIA");
            if (india) {
                setSelectedCountry(india.id);
            }
            setBillingDetails({
                BillBuyerName: "",
                BillAddress: "",
                BillArea: "",
                BillState: "",
                BillCountry: "India",  // For display purposes
                BillZIP: "",
                BillMobile: "",
                TradeName: "",
                GSTIN: ""
            });
            setIsOpen(true); // Open the modal for adding a new address
        } else {
            alert("You can only have a maximum of 3 billing addresses.");
        }

    };

    // Handle radio button change (Address Type Selection)
    const handleAddressTypeChange = (e) => {
        const newType = parseInt(e.target.value);
        setAddressType(newType);
        if (newType === 1) {
            resetForm();
        } else {
            resetForm();
        }
    };

    const handleEditAddress = (addressId, typeId) => {
       
        setAddressId(addressId);
        setAddressType(typeId); // Set the address type (Shipping or Billing)

        if (typeId === 1) { // Shipping Address
            const address = addressShip.find((addr) => addr.id === addressId);
            if (address) {
                setShippingDetails({
                    shipAddress: address.shipAddress,
                    shipArea: address.shipArea,
                    shipState: address.shipState,
                    shipCountry: address.shipCountry,
                    shipZIP: address.shipZIP,
                    shipMobile: address.shipMobile,
                    shipDefault: address.shipDefault,
                    shipBuyerName: address.shipBuyerName, // Also include buyer's name
                });
            }
        } else if (typeId === 2) { // Billing Address
            const address = addressBill.find((addr) => addr.id === addressId);
            if (address) {
                setBillingDetails({
                    billAddress: address.billAddress,
                    billArea: address.billArea,
                    billState: address.billState,
                    billCountry: address.billCountry,
                    billZIP: address.billZIP,
                    billMobile: address.billMobile,
                    billDefault: address.billDefault,
                    billBuyerName: address.billBuyerName, // Also include buyer's name
                    tradeName: address.tradeName,
                    gstin: address.gstin,
                });
            }
        }

        setIsOpen(true); // Open the modal
    };

    // Hide Trade Name and GST fields if it's a Shipping address (TypeId: 1)
    //const isShipping = addressTypeId === 1;

    // Handle country selection change
    const handleCountryChange = (e) => {
        const selectedCountryId = e.target.value; // Get the selected country id
        const selectedCountryName = e.target.options[e.target.selectedIndex].text; // Get the selected country name

        setSelectedCountry(selectedCountryId); // Set the selected country by id

        // Update the shipping details with both country name and id
        setShippingDetails({
            ...shippingDetails,
            ShipCountry: selectedCountryName, // For display purposes (name)
        });

        // If you're updating billing details, you may need to add similar logic for billing:
        setBillingDetails({
            ...billingDetails,
            BillCountry: selectedCountryName, // For display purposes (name)
        });
    };


    // Handle selection of shipping address
    const handleShipAddressSelection = async (addressId) => {
       
        if (addressId !== defaultShipAddressId) {
            const confirmChange = window.confirm("Would you like to select this address for delivery?");
            if (confirmChange) {
                //setDefaultShipAddressId(addressId);
                // Optionally, call the API to update the default address

                try {

                    const response = await fetch(`https://igapi.heuristticminds.com/api/BuyerList/Update-ChangeBuyerDefaultAddress?buyer_id=${userInfo.buyer_id}&addressType=1&addressId=${addressId}`, {
                        method: 'PUT',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                    });
                    if (response.ok) {
                        fetchAddresses();
                    }
                }
                catch {
                }
            }
        }
    };

    // Handle selection of billing address
    const handleBillAddressSelection = async (addressId) => {
       
        if (addressId !== defaultBillAddressId) {
            const confirmChange = window.confirm("Would you like to select this address for billing?");
            if (confirmChange) {
                //setDefaultBillAddressId(addressId);
                // Optionally, call the API to update the default address

                try {

                    const response = await fetch(`https://igapi.heuristticminds.com/api/BuyerList/Update-ChangeBuyerDefaultAddress?buyer_id=${userInfo.buyer_id}&addressType=2&addressId=${addressId}`, {
                        method: 'PUT',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                    });
                    if (response.ok) {
                        fetchAddresses();
                    }
                }
                catch {
                }
            }
        }
    };

    const handleSaveAddress = async () => {
        let formData = {
            modeType: addressId ? 2 : 1, // Determine if adding or editing
            addressId: addressId || 0,  // Use existing addressId for edit or 0 for new
            buyer_Id: userInfo.buyer_id,
        };

        // Depending on addressType, add shipping or billing details
        if (addressType === 1) { // Shipping
            formData = {
                ...formData, // Spread the existing properties
                addressType: 1, // Shipping
                buyerName: shippingDetails.shipBuyerName,
                address: shippingDetails.shipAddress,
                area: shippingDetails.shipArea,
                state: shippingDetails.shipState,
                countryId: selectedCountry, // Use country ID, not name
                zIP: shippingDetails.shipZIP,
                mobile: shippingDetails.shipMobile,
                tradeName: "",
                gstin: "",
            };
        } else { // Billing
            formData = {
                ...formData, // Spread the existing properties
                addressType: 2, // Billing
                buyerName: billingDetails.billBuyerName,
                address: billingDetails.billAddress,
                area: billingDetails.billArea,
                state: billingDetails.billState,
                countryId: selectedCountry, // Use country ID, not name
                zIP: billingDetails.billZIP,
                mobile: billingDetails.billMobile,
                tradeName: billingDetails.tradeName || '', // Keep tradeName only for billing
                gstin: billingDetails.gstin || '', // Keep GSTIN only for billing
            };
        }

        try {
            // Make the API call to save the form data
            const response = await fetch('https://igapi.heuristticminds.com/api/BuyerList/Add-InsertUpdateBuyerAddress', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
            });

            if (response.ok) {
                await fetchAddresses();  // Call the fetch function to refresh the addresses
            } else {
                console.error('Error saving form data:', response.statusText);
            }
        } catch (error) {
            console.error('Error saving form data:', error);
        }

        // After saving, reset the form and close the modal
        setIsOpen(false);
        resetForm();
    };

    const resetForm = () => {
        setShippingDetails({
            shipBuyerName: "",
            shipAddress: "",
            shipArea: "",
            shipState: "",
            shipCountry: "India",
            shipZIP: "",
            shipMobile: ""
        });
        setBillingDetails({
            billBuyerName: "",
            billAddress: "",
            billArea: "",
            billState: "",
            billCountry: "India",
            billZIP: "",
            billMobile: "",
            tradeName: "",
            gstin: ""
        });
    };

    const handleRemoveAddress = async (addressId, addressType, defaultAdd) => {

        if (defaultAdd === 1) {
            alert("This is the default address and cannot be deleted.");
            return;
        }
        // Ask for confirmation before proceeding with deletion
        const confirmed = window.confirm('Are you sure you want to remove this address?');

        if (!confirmed) {
            // If the user cancels, do nothing
            return;
        }
        try {
            const response = await fetch(`https://igapi.heuristticminds.com/api/BuyerList/Delete-DeleteBuyerAddress?addressType=${addressType}&addressId=${addressId}`, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            if (response.ok) {
                // Refresh the address list after successful deletion
                fetchAddresses();  // Ensure fetchAddresses is available in the component
            } else {
                console.error('Error removing address:', response.statusText);
            }
        } catch (error) {
            console.error('Error removing address:', error);
        }
    };

    const handleImageChange = async (e) => {
        const file = e.target.files[0]; // Get the selected file
        if (!file) {
            console.error('No file selected');
            return;
        }

        // Immediately upload the image after selection
        try {
            await handleProfileImageUpload(file);
        } catch (error) {
            console.error('Error during image change:', error);
        }
    };


    const handleProfileImageUpload = async(file) =>{
        debugger;
        const formData = new FormData();
        formData.append('profileImage', file);
        try {
            
            const uploadResponse = await axios.post('http://localhost:3000/uploadImage/uploadProfileImage', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            
            const uploadedImageName = uploadResponse.data.fileUrl;
            const imageDetails = {
                    image: uploadedImageName,
                    id: userInfo.buyer_id,
                    createdBy: userInfo.buyer_id
                };
                return axios.post('https://igapi.heuristticminds.com/api/UsersList/Add-SaveUserProfileImage', imageDetails);                   

        } catch (error) {
            console.error('Error uploading files:', error);
        }
    }


    return (
        <>
            <Header />
            <div style={{ marginTop: '150px' }}>
                <div className="container">
                    <div className="row">
                        <div className="col-sm-12 mb-3">
                            <div className="bg-light p-3 border">
                                <div className="row">
                                    <div className="col-sm-4 text-center">
                                        <div className="pd_display">

                                            {/* Label makes the image clickable */}
                                                <label htmlFor="uploadImage" style={{ cursor: 'pointer' }}>
                                                    <img 
                                                        src={userData.image === "NA" ? "../../images/admin-male.jpg" : `../../images/profile/thumbnail/${userData.image}`}
                                                        alt="Profile"  
                                                    />
                                                </label>
                                            {/* Hidden file input */}
                                            <input
                                                id="uploadImage"
                                                type="file"
                                                style={{ display: 'none' }}
                                                onChange={handleImageChange}
                                            />  
                                        </div>
                                    </div>
                                    <div className="col-sm-8">
                                        <h4 className="fs-4 mt-3 mb-4">Account Details</h4>
                                        <p className="pdtitle"><span>Registered Name:</span>{userData.username}</p>
                                        <p className="pdtitle"><span>Registered Email:</span>{userData.email}</p>
                                        <p className="pdtitle"><span>Registered Mobile:</span>{userData.phonecode}-{userData.mobile}</p>
                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6">
                            <div className="border mb-4 p-3">
                                <div className="fs-4">Shipping Address</div>
                                <button className="btn_border" onClick={handleAddNewShipAddress}><i className="bi bi-plus"></i> Add New Shipping Address</button>
                                {addressShip.length === 0 ? (
                                    <div>
                                        <div className="fs-6">No Address Found</div>
                                        <button className="btn_border" onClick={toggleMenu}><i className="bi bi-plus"></i> Add an address</button>
                                    </div>
                                ) : (
                                    <div>
                                        <div className="fs-6">Choose a Shipping Address</div>
                                        <ul className="list1">
                                            {addressShip.map((address) => (
                                                <li key={address.id}>
                                                    <div className="address_box">
                                                        <input
                                                            type="radio"
                                                            id={`shipAddress-${address.id}`}
                                                            name="shipAddress"
                                                            checked={address.shipDefault === 1}
                                                            onChange={() => handleShipAddressSelection(address.id)}
                                                        />
                                                        <label htmlFor={`shipAddress-${address.id}`}>
                                                            <b>{address.shipBuyerName}</b>
                                                            <p>{address.shipAddress}, {address.shipArea}, {address.shipState}, {address.shipZIP}, {address.shipCountry}</p>
                                                            <p>{address.shipMobile}</p>
                                                            <div className="d-flex">
                                                                <button className="btn_border me-2" onClick={() => handleEditAddress(address.id, 1)}>Edit</button>
                                                                <button className="btn_border" onClick={() => handleRemoveAddress(address.id, 1, address.shipDefault)}>Remove</button>
                                                            </div>
                                                        </label>
                                                    </div>
                                                </li>
                                            ))}
                                        </ul>
                                        {/* <button className="btn2 bg-dark text-white border-0 mt-3">Save Delivery Address</button> */}
                                    </div>
                                )}

                                {/* Add New Address Form */}
                                <div className={`off_canvas ${isOpen ? 'open' : ''}`}>
                                    <div className="off_wrap">
                                        <div className="offcanvas_header shadow-sm">
                                            <div className="modal-header">
                                                <h5>{addressType === 1 ? "Add Shipping Address" : "Add Billing Address"}</h5>
                                                {/* <button onClick={() => setIsOpen(false)} className="close-btn">X</button> */}
                                            </div>
                                            <button onClick={toggleMenu} className="close_btn"><i className="bi bi-x-lg"></i></button>
                                        </div>
                                        <div className="offcanvas_body">
                                            <div className="row">
                                                <div className="col-sm-12 mb-2">
                                                    <input
                                                        type="radio"
                                                        id="shipping"
                                                        name="addressType"
                                                        value="1"
                                                        checked={addressType === 1}
                                                        onChange={handleAddressTypeChange}
                                                    />
                                                    <label htmlFor="shipping" className="ps-1 me-4">Shipping Address</label>

                                                    <input
                                                        type="radio"
                                                        id="billing"
                                                        name="addressType"
                                                        value="2"
                                                        checked={addressType === 2}
                                                        onChange={handleAddressTypeChange}
                                                    />
                                                    <label htmlFor="billing" className="ps-1">Billing Address</label>
                                                </div>

                                                <div className="col-sm-12">
                                                    <div className="txt_wrap">
                                                        <span className="txt_lbl">Buyer Name</span>
                                                        <input
                                                            type="text"
                                                            className="txt1"
                                                            placeholder="Enter buyer name"
                                                            value={addressType === 1 ? shippingDetails.shipBuyerName : billingDetails.billBuyerName}
                                                            onChange={(e) =>
                                                                addressType === 1
                                                                    ? setShippingDetails({ ...shippingDetails, shipBuyerName: e.target.value })
                                                                    : setBillingDetails({ ...billingDetails, billBuyerName: e.target.value })
                                                            }
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-sm-6">
                                                    <div className="txt_wrap">
                                                        <span className="txt_lbl">Country</span>
                                                        <select
                                                            className="txt1"
                                                            value={selectedCountry} // selectedCountry should hold the name
                                                            onChange={handleCountryChange}
                                                        >
                                                            {countries.map((country) => (
                                                                <option key={country.id} value={country.id}>
                                                                    {country.countryName}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-sm-6">
                                                    <div className="txt_wrap">
                                                        <span className="txt_lbl">Pin Code</span>
                                                        <input
                                                            type="text"
                                                            className="txt1"
                                                            placeholder="Enter PIN code"
                                                            value={addressType === 1 ? shippingDetails.shipZIP : billingDetails.billZIP}
                                                            onChange={(e) =>
                                                                addressType === 1
                                                                    ? setShippingDetails({ ...shippingDetails, shipZIP: e.target.value })
                                                                    : setBillingDetails({ ...billingDetails, billZIP: e.target.value })
                                                            }
                                                        />
                                                    </div>
                                                </div>

                                                <div className="col-sm-12">
                                                    <div className="txt_wrap">
                                                        <span className="txt_lbl">Address</span>
                                                        <input
                                                            type="text"
                                                            className="txt1"
                                                            placeholder="Enter address"
                                                            value={addressType === 1 ? shippingDetails.shipAddress : billingDetails.billAddress}
                                                            onChange={(e) =>
                                                                addressType === 1
                                                                    ? setShippingDetails({ ...shippingDetails, shipAddress: e.target.value })
                                                                    : setBillingDetails({ ...billingDetails, billAddress: e.target.value })
                                                            }

                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-sm-6">
                                                    <div className="txt_wrap">
                                                        <span className="txt_lbl">City/Town</span>
                                                        <input
                                                            type="text"
                                                            className="txt1"
                                                            placeholder="Enter city/town"
                                                            value={addressType === 1 ? shippingDetails.shipArea : billingDetails.billArea}
                                                            onChange={(e) =>
                                                                addressType === 1
                                                                    ? setShippingDetails({ ...shippingDetails, shipArea: e.target.value })
                                                                    : setBillingDetails({ ...billingDetails, billArea: e.target.value })
                                                            }
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-sm-6">
                                                    <div className="txt_wrap">
                                                        <span className="txt_lbl">State</span>
                                                        <input
                                                            type="text"
                                                            className="txt1"
                                                            placeholder="Enter State"
                                                            value={addressType === 1 ? shippingDetails.shipState : billingDetails.billState}
                                                            onChange={(e) =>
                                                                addressType === 1
                                                                    ? setShippingDetails({ ...shippingDetails, shipState: e.target.value })
                                                                    : setBillingDetails({ ...billingDetails, billState: e.target.value })
                                                            }
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-sm-12">
                                                    <div className="txt_wrap">
                                                        <span className="txt_lbl">Mobile No.</span>
                                                        <input
                                                            type="text"
                                                            className="txt1"
                                                            placeholder="Enter Mobile"
                                                            value={addressType === 1 ? shippingDetails.shipMobile : billingDetails.billMobile}
                                                            onChange={(e) =>
                                                                addressType === 1
                                                                    ? setShippingDetails({ ...shippingDetails, shipMobile: e.target.value })
                                                                    : setBillingDetails({ ...billingDetails, billMobile: e.target.value })
                                                            }
                                                        />
                                                    </div>
                                                </div>
                                                {addressType !== 1 && (
                                                    <>
                                                        <div className="col-sm-12">
                                                            <div className="txt_wrap">

                                                                <span className="txt_lbl">Trade / Company Name (Optional)</span>
                                                                <input
                                                                    type="text"
                                                                    className="txt1"
                                                                    placeholder="Enter Trade/Company name"
                                                                    //value={billingDetails.tradeName}
                                                                    value={addressType === 1 ? shippingDetails.tradeName : billingDetails.tradeName}
                                                                    onChange={(e) =>
                                                                        addressType === 1
                                                                            ? setShippingDetails({ ...shippingDetails, tradeName: e.target.value })
                                                                            : setBillingDetails({ ...billingDetails, tradeName: e.target.value })}
                                                                //setBillingDetails({ ...billingDetails, tradeName: e.target.value })}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-sm-12">
                                                            <div className="txt_wrap">
                                                                <span className="txt_lbl">GST No (Optional)</span>
                                                                <input
                                                                    type="text"
                                                                    className="txt1"
                                                                    placeholder="Enter GSTIN"
                                                                    //value={billingDetails.gstin}
                                                                    value={addressType === 1 ? shippingDetails.gstin : billingDetails.gstin}
                                                                    onChange={(e) =>
                                                                        addressType === 1
                                                                            ? setShippingDetails({ ...shippingDetails, gstin: e.target.value })
                                                                            : setBillingDetails({ ...billingDetails, gstin: e.target.value })}
                                                                //setBillingDetails({ ...billingDetails, gstin: e.target.value })}
                                                                />
                                                            </div>
                                                        </div>
                                                    </>)}

                                                <div className="col-sm-12 text-center">
                                                    <button className="btn2 bg-dark text-white border-0 mt-2 w-50" onClick={handleSaveAddress} style={{ transition: 'none' }}>
                                                        {addressType === 1 ? "Save Shipping Address" : "Save Billing Address"}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6">
                            <div className="border mb-4 p-3">
                                <div className="fs-4">Billing Address</div>
                                <div>
                                    <div className="fs-6">Choose a Billing Address</div>
                                    <button className="btn_border" onClick={handleAddNewBillAddress}><i className="bi bi-plus"></i> Add New Billing Address</button>
                                    {addressBill.length === 0 ? (
                                        <div>No Billing Address Found</div>
                                    ) : (
                                        <ul className="list1">
                                            {addressBill.map((address) => (
                                                <li key={address.id}>
                                                    <div className="address_box">
                                                        <input
                                                            type="radio"
                                                            id={`billAddress-${address.id}`}
                                                            name="billAddress"
                                                            checked={address.billDefault === 1}
                                                            onChange={() => handleBillAddressSelection(address.id)}
                                                        />
                                                        <label htmlFor={`billAddress-${address.id}`}>
                                                            <b>{address.billBuyerName}</b>
                                                            <p>{address.billAddress}, {address.billArea}, {address.billState}, {address.billZIP}, {address.billCountry}</p>
                                                            <p>{address.billMobile}</p>
                                                            <p><b>{address.tradeName}</b></p>
                                                            <p>{address.gstin}</p>
                                                            <div className="d-flex">
                                                                <button className="btn_border me-2" onClick={() => handleEditAddress(address.id, 2)}>Edit</button>
                                                                <button className="btn_border" onClick={() => handleRemoveAddress(address.id, 2, address.billDefault)}>Remove</button>
                                                            </div>
                                                        </label>
                                                    </div>
                                                </li>
                                            ))}
                                        </ul>
                                    )}
                                    {/*<button className="btn2 bg-dark text-white border-0 mt-3 ">Save Delivery Address</button>*/}

                                </div>
                            </div>
                        </div>



                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};

export default MyAccount;